import React, { useState, useEffect } from 'react';

import { Modal, Grid, Box, Typography, useMediaQuery } from '@mui/material';

import GroupFormationCard from '../GroupFormationCard';

const SavedGroupFormationModal = (props) => {
    const modalStyle = {
        position: 'absolute',
        top: '45%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: "white",
        maxHeight: "70%",
        minHeight: "250px",
        boxShadow: 24,
        padding: 20,
        borderRadius: 5,
        overflow: "auto",
    };

    const [width, setWidth] = useState("600px");
    const sm = useMediaQuery('(min-width:600px)');
    const md = useMediaQuery('(min-width:900px)');
    const lg = useMediaQuery('(min-width:1200px)');

    useEffect(() => {
        var width;
        if (sm)
            if (md)
                if (lg) width = "920px";
                else width = "700px";
            else width = "475px";
        else width = "250px";
        setWidth(width);
    }, [sm, md, lg]);
    
    return (
        <Modal
        open={props.open}
        onClose={props.handleClose}
        >
            <Box style={modalStyle} sx={{width: width}}>
                <Typography variant="h5" style={{marginBottom: "10px"}}>Saved Runs</Typography>
                <Grid container spacing={2}>
                    {props.savedGroupFormations && props.savedGroupFormations.map((savedGroups, i) =>{
                        return (
                            <Grid item key={i} lg={3} md={4} sm={6} xs={12}>
                                <GroupFormationCard 
                                    loadSavedGroups={props.loadSavedGroups}
                                    handleDelete={props.deleteSavedData} 
                                    savedGroups={savedGroups}
                                />
                            </Grid>
                        )
                    })}
                </Grid>
            </Box>
        </Modal>
    );
}

export default SavedGroupFormationModal; 
